import { apiClient } from '@/lib/api-client';
import type {
  CreateHarrisonPromptInput,
  CreatedHarrisonPrompt,
  HarrisonDraft,
  HarrisonModels,
  HarrisonPromptVersion,
} from '../../domain/entities/harrison.entity';

/**
 * O assistente do comentário oficial (o Harrison atrás do monolith, nunca
 * chamado direto pelo front). Um método por rota, sem regra.
 */
export class HarrisonApiDatasource {
  async getModels(): Promise<HarrisonModels> {
    const { data } = await apiClient.get<HarrisonModels>(
      '/admin/content/official-comment-assistant/models',
    );
    return data;
  }

  /** Síncrona no back e lenta (o LLM leva dezenas de segundos). */
  async draftOfficialComment(
    questionId: string,
    model: string | undefined,
    signal?: AbortSignal,
  ): Promise<HarrisonDraft> {
    const { data } = await apiClient.post<HarrisonDraft>(
      `/admin/content/questions/${encodeURIComponent(questionId)}/official-comment/draft`,
      model ? { model } : {},
      { signal },
    );
    return data;
  }

  async listPrompts(): Promise<HarrisonPromptVersion[]> {
    const { data } = await apiClient.get<{ items: HarrisonPromptVersion[] }>(
      '/admin/content/official-comment-assistant/prompts',
    );
    return data.items;
  }

  async createPrompt(
    input: CreateHarrisonPromptInput,
  ): Promise<CreatedHarrisonPrompt> {
    const { data } = await apiClient.post<CreatedHarrisonPrompt>(
      '/admin/content/official-comment-assistant/prompts',
      input,
    );
    return data;
  }

  async makePromptDefault(versionId: string): Promise<HarrisonPromptVersion> {
    const { data } = await apiClient.put<HarrisonPromptVersion>(
      `/admin/content/official-comment-assistant/prompts/${encodeURIComponent(versionId)}/default`,
    );
    return data;
  }
}
